import React from 'react';
import { Line } from 'react-chartjs-2';

const LineGraph = () => {
  const data = {
    labels: [
      'O',
      'A+',
      'A',
      'B+',
      'B',
      'C',
      'P',
      'F',
      'R',
      'AB',
      'I',
      'S',
      'U',
    ],
    datasets: [
      {
        label: 'Letter Grade',
        data: [10, 20, 30, 40, 50, 60, 70, 80, 0, 10, 30, 20, 40],
        fill: true,
        borderColor: 'rgba(75, 192, 192, 0.6)',
      },
    ],
  };

  const options = {
    title: {
      display: true,
      text: 'Student Grades and Marks',
      fontSize: 20,
    },
    legend: {
      display: true,
      position: 'bottom',
    },
    scales: {
      yAxes: [
        {
          ticks: {
            // beginAtZero: true,
            // min: 0,
            // max: 100,
          },
          scaleLabel: {
            display: true,
            labelString: 'Students',
          },
        },
      ],
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Grades',
          },
        },
      ],
    },
  };

  return (
    <div>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineGraph;
